import React, { createContext, useContext, useReducer, useEffect } from 'react';
import io from 'socket.io-client';

const MessagingContext = createContext();

const initialState = {
    contacts: [],
    selectedContact: null,
    messages: {}, // { contactId: [messages] }
    loading: false,
    error: null,
    searchQuery: '',
    filter: 'all', // 'all', 'unread'
    
    // Advanced Filters
    selectedTags: [],
    selectedBranches: [],
    selectedQrCodes: [],
    selectedFormIds: [],
    selectedAdmissionStatuses: [],
};

function messagingReducer(state, action) {
    switch (action.type) {
        case 'SET_CONTACTS':
            return { ...state, contacts: action.payload, loading: false };
        case 'SELECT_CONTACT':
            return { ...state, selectedContact: action.payload };
        case 'SET_MESSAGES':
            return { 
                ...state, 
                messages: { 
                    ...state.messages, 
                    [action.contactId]: action.payload 
                } 
            };
        case 'ADD_MESSAGE':
            const { contactId, message } = action.payload;
            const existingMessages = state.messages[contactId] || [];
            return {
                ...state,
                messages: {
                    ...state.messages,
                    [contactId]: [...existingMessages, message]
                }
            };
        case 'UPDATE_MESSAGE_STATUS':
            // Logic to update read/delivered status
            return state;
        case 'SET_SEARCH':
            return { ...state, searchQuery: action.payload };
        case 'SET_FILTER':
            return { ...state, filter: action.payload };
        case 'UPDATE_FILTERS':
            return { ...state, ...action.payload };
        case 'SET_LOADING':
            return { ...state, loading: action.payload };
        case 'SET_ERROR':
            return { ...state, error: action.payload };
        default:
            return state;
    }
}

export const MessagingProvider = ({ children }) => {
    const [state, dispatch] = useReducer(messagingReducer, initialState);
    
    // Mock initialization for now
    useEffect(() => {
        dispatch({ type: 'SET_LOADING', payload: true });
        // Simulating API fetch
        setTimeout(() => {
            const mockContacts = [
                { id: '1', name: 'John Doe', lastMessage: 'Hey, how are you?', time: '10:30 AM', unreadCount: 2, lastInteraction: new Date() },
                { id: '2', name: 'Jane Smith', lastMessage: 'The report is ready.', time: 'Yesterday', unreadCount: 0, lastInteraction: new Date(Date.now() - 25 * 3600 * 1000) }, // > 24h
                { id: '3', name: 'Rizee Support', lastMessage: 'Thank you for contacting us.', time: 'Monday', unreadCount: 0, lastInteraction: new Date() },
            ];
            dispatch({ type: 'SET_CONTACTS', payload: mockContacts });
        }, 1000);
    }, []);

    return (
        <MessagingContext.Provider value={{ state, dispatch }}>
            {children}
        </MessagingContext.Provider>
    );
};

export const useMessaging = () => {
    const context = useContext(MessagingContext);
    if (!context) {
        throw new Error('useMessaging must be used within a MessagingProvider');
    }
    return context;
};
